import React, { useEffect, useState } from "react"
import C3Chart from "react-c3js"
import "c3/c3.css"

const DoctorRatingDonut = ({ doctor }) => {
  const [columns, setColumns] = useState([["Rating", 0], ["Remaining", 5]])

  useEffect(() => {
    const rating = Number(doctor?.rating) || 0
    const clamped = Math.max(0, Math.min(rating, 5))
    setColumns([
      ["Remaining", 5 - clamped],
      ["Rating", clamped],
    ])
  }, [doctor])

  const rating = Number(doctor?.rating) || 0
  const data = { columns, type: "donut" }
  const donut = { title: `${rating} / 5`, width: 30, label: { show: true } }
  const color = { pattern: ["#2990DF", "#E8E8E8"] }
  const size = { height: 250 }

  return <C3Chart data={data} donut={donut} color={color} size={size} />
}

export default DoctorRatingDonut
